import { render, staticRenderFns } from "./tabs-done.vue?vue&type=template&id=32a31d64"
import script from "./tabs-done.vue?vue&type=script&lang=js"
export * from "./tabs-done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports